module.exports = __webpack_public_path__ + "static/media/waveMiddle.5048803c.svg";